import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Colton Wiscombe
 * id DDBEC0DB-97A9-439B-9FC0-5A05F51ED5E3
 * name water-alert
 * version: 5.4.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/water-alert.svg
 * tags
 * - Alert / Error 
 * - Agriculture 
 */
export const WaterAlertIcon = createSvgIcon(<><path d="M10 3.25C10 3.25 16 10 16 14C16 17.31 13.31 20 10 20S4 17.31 4 14C4 10 10 3.25 10 3.25M20 7V13H18V7H20M18 17H20V15H18V17Z" /></>, 'WaterAlertIcon');
export default WaterAlertIcon